/* Huna Redesign v1 — shared interactions. Guarded to run once per page. */
(function () {
  if (window.HunaThemeLoaded) return;
  window.HunaThemeLoaded = true;

  // 1. Scroll-reveal
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('huna-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    var watch = function () {
      var nodes = document.querySelectorAll('.huna-reveal:not(.huna-in)');
      nodes.forEach(function (el, i) {
        if (!el.dataset.hunaD) {
          el.dataset.hunaD = '1';
          el.style.transitionDelay = (Math.min(i % 4, 4) * 70) + 'ms';
        }
        io.observe(el);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', watch);
    } else {
      watch();
    }

    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () { watch(); });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  } else {
    var s = document.createElement('style');
    s.textContent = '.huna-reveal{opacity:1!important;transform:none!important}';
    document.head.appendChild(s);
  }

  // 2. FAQ accordion
  document.addEventListener('click', function (e) {
    var q = e.target.closest && e.target.closest('.huna-faq-q');
    if (q) {
      var item = q.parentElement;
      if (item) item.classList.toggle('huna-open');
    }
  });

  // 3. Generic select / tab switcher
  document.addEventListener('click', function (e) {
    var opt = e.target.closest && e.target.closest('[data-huna-select]');
    if (!opt) return;
    var group = opt.getAttribute('data-huna-select');
    document.querySelectorAll('[data-huna-select="' + group + '"]').forEach(function (o) {
      o.classList.remove('huna-sel');
    });
    opt.classList.add('huna-sel');
    var target = opt.getAttribute('data-huna-target');
    if (target) {
      document.querySelectorAll('[data-huna-pane="' + group + '"]').forEach(function (p) {
        p.classList.remove('huna-show');
      });
      var pane = document.querySelector('[data-huna-pane="' + group + '"][data-huna-id="' + target + '"]');
      if (pane) pane.classList.add('huna-show');
    }
  });
})();
